import type React from 'react'

interface LogoutIconProps {
  size?: number | string
  color?: string
  className?: string
}

const LogoutIcon: React.FC<LogoutIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Logout Icon'}
      role="img"
    >
      <path
        d="M20.7499 15.2705V8.75C20.7498 6.58958 20.3131 5.27148 19.5165 4.47461C18.7196 3.67774 17.4009 3.24023 15.2401 3.24023H15.1102C13.1539 3.24024 11.8862 3.59967 11.0751 4.25781C10.2848 4.89918 9.79267 5.93714 9.64733 7.625C9.61157 8.03747 9.24834 8.34314 8.8358 8.30762C8.42323 8.27204 8.11776 7.90867 8.15319 7.49609C8.31782 5.58425 8.90532 4.08642 10.1297 3.09277C11.3336 2.11593 13.0166 1.74024 15.1102 1.74023H15.2401C17.5493 1.74023 19.3614 2.19843 20.577 3.41406C21.7924 4.62965 22.2498 6.44112 22.2499 8.75V15.2705C22.2498 17.5794 21.7924 19.3909 20.577 20.6064C19.3614 21.8221 17.5493 22.2803 15.2401 22.2803H15.1102C13.0318 22.2803 11.3595 21.9094 10.1581 20.9482C8.93498 19.9698 8.3396 18.4938 8.16393 16.6094C8.12573 16.1971 8.4284 15.8324 8.84069 15.7939C9.25311 15.7555 9.61865 16.0583 9.65709 16.4707C9.81142 18.1261 10.3053 19.1458 11.0946 19.7773C11.9057 20.4262 13.1687 20.7803 15.1102 20.7803H15.2401C17.4009 20.7803 18.7196 20.3428 19.5165 19.5459C20.3131 18.749 20.7498 17.4309 20.7499 15.2705Z"
        fill={color}
      />
      <g opacity="0.4">
        <path
          d="M14.9989 11.2503C15.4131 11.2503 15.7489 11.5861 15.7489 12.0003C15.7489 12.4145 15.4131 12.7503 14.9989 12.7503H3.61899C3.20477 12.7503 2.86899 12.4145 2.86899 12.0003C2.86899 11.5861 3.20477 11.2503 3.61899 11.2503H14.9989Z"
          fill={color}
        />
        <path
          d="M5.31918 8.12045C5.61201 7.82762 6.08682 7.82775 6.37973 8.12045C6.67262 8.41334 6.67262 8.8881 6.37973 9.181L3.55942 12.0003L6.37973 14.8206C6.67262 15.1135 6.67262 15.5883 6.37973 15.8812C6.08681 16.1738 5.61198 16.174 5.31918 15.8812L1.96957 12.5306C1.67687 12.2377 1.67674 11.7629 1.96957 11.4701L5.31918 8.12045Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default LogoutIcon
